import { yupResolver } from '@hookform/resolvers/yup';
import Form from '../../../Form/Form';
import { chooseRegisterData } from './ChooseRegisterModalForm.data';
import { ChooseRegisterModalFormSchema } from './ChooseRegisterModalForm.types';
import { useForm, useWatch } from 'react-hook-form';
import { getChooseRegisterSchema } from './ChooseRegisterModalForm.schema';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();

  const formProps = useForm<ChooseRegisterModalFormSchema>({
    resolver: yupResolver(getChooseRegisterSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { control, handleSubmit } = formProps;

  const userType = useWatch({
    control,
    name: 'userType',
  });

  const onSubmit = handleSubmit(({ userType }) => {
    if (userType === UserRoles.Entreprise) {
      navigate('/step_wizard/ENT');
    } else {
      navigate('/step_wizard/PUB');
    }
  });

  return (
    <Form<ChooseRegisterModalFormSchema>
      data={chooseRegisterData}
      {...{ formProps, onSubmit }}
      isCompany={userType === UserRoles.Entreprise}
    />
  );
};
